export { default } from "./SearchModalPlaceholder";
